export const selfPaymentCheck = { value: '201', label: 'Self Pay Payment - Check' };
export const selfPaymentCreditCard = { value: '202', label: 'Self Pay Payment - Check' };
export const selfPaymentCash = { value: '203', label: 'Self Pay Payment - Check' };
export const allPaymentCodes = [selfPaymentCheck, selfPaymentCreditCard, selfPaymentCash];
